import RoutesLoader from 'modules/common/Routes/';
import { lazyLoad } from 'utils/loadable';
/**
 *
 * Web App
 *
 */
import { routes } from './routes';

const WebPrivateRoute = lazyLoad(
  () =>
    import(
      /*  webpackChunkName: 'webEncloserLayout', webpackPrefetch: true */ './common/WebEncloser'
    ),
  module => module.default,
  { fallback: null },
);

export default function WebApp() {
  return (
    <RoutesLoader routes={routes} PrivateRouteEncloser={WebPrivateRoute} />
  );
}
